import ChatbotSection from "@/components/enea/ChatbotSection";

export default function Beta() {
  return (
    <div className="min-h-screen bg-[#F5F8FA]">
      <div className="bg-[#0b2545] text-center px-4 py-2.5" data-testid="beta-banner">
        <span className="text-xs sm:text-sm text-[#a9d6e5] font-medium tracking-wide">
          🧪 <span className="text-white font-semibold">Versione Beta</span> — il tuo feedback è prezioso 🙏
        </span>
      </div>
      <ChatbotSection beta />
      <div className="text-center pb-8 -mt-4">
        <p className="text-[11px] text-slate-400">Gruppo Vela · Home Exchange Copilot AI · Ambiente di beta test</p>
      </div>
    </div>
  );
}
